module.exports = __webpack_public_path__ + "img/chart.361bff87.svg";